<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华视频课堂 - 用<common-data name="appShortName_37"/>来做股票价值投资</div>
        <p class="index-module_textWrap_3ygOc">认可价值投资的理念，但信心不足，市场一有风吹草动便患得患失？缺少必要的行业分析和企业分析能力，对于企业的盈利质量和财务风险常常看不透彻？选股找不到切入点、估值时拿捏不准、持有时缺乏定力？
        </p>
        <p class="index-module_textWrap_3ygOc">这是为什么呢？因为你缺少股票价值分析的工具软件！现在有了<common-data name="appShortName_37"/>，这些不再是问题。 <common-data name="appShortName_37"/>聚焦股票价值分析，助力你拔除痛点，拓展价投分析能力边界，自己做基金经理，走上价值投资的坦途。
        </p>
        <p class="index-module_textWrap_3ygOc">对机构来说，<common-data name="appShortName_37"/>作为基金经理必备的价投研究工具软件，丰富的数据、实用的功能设计，为你节省时间和精力，提高投研工作效率。</p>
        <p class="index-module_textWrap_3ygOc">
            本期课程我们将围绕“价值投资”这一话题，结合案例，为大家深入解读如何使用<common-data name="appShortName_37"/>的基本面定价、财务画像、利润滤镜、风险甄别、EVA分析等工具，对上市企业进行估值分析、刻画企业基本面肖像、分析企业盈利质量和财务风险。
        </p>
        <p class="index-module_textWrap_3ygOc">有了<common-data name="appShortName_37"/>，自己做基金经理！</p>
        <p class="index-module_textWrap_3ygOc">
            课程：<common-data name="appShortName_37"/>价投分析，拓展价投分析能力边界，助力深度价投研究
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" colspan="2">内容</th>
                    <th valign="top" width="18%">讲师</th>
                </tr>
                <tr>
                    <td rowspan="3" align="center" style="padding-left: 0;text-indent:0">发现市场风向</td>
                    <td>板块聚焦——寻找行业价值洼地、精准地把握节奏。</td>
                    <td rowspan="9" align="center" style="padding-left: 0;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td>周期与趋势——四分法周期划分，研判经济周期波动。</td>
                </tr>
                <tr>
                    <td>市场相关性——寻找经济传导逻辑、优化行业投资组合。</td>
                </tr>
                <tr>
                    <td rowspan="4" align="center" style="padding-left: 0;text-indent:0">看懂财务报表</td>
                    <td>财务画像——重构财报勾稽关系，刻画企业肖像。</td>
                </tr>
                <tr>
                    <td>利润滤镜——财报脱水，探究企业盈利质量。</td>
                </tr>
                <tr>
                    <td>风险甄别——以净现比为核心，分析企业财务风险。</td>
                </tr>
                <tr>
                    <td>大数据分析——AI人工智能技术的创新应用，个股分析报告。</td>
                </tr>
                <tr>
                    <td rowspan="2" align="center" style="padding-left: 0;text-indent:0">找准买入时机</td>
                    <td>定价数据——股票定价计算不再是大型专业机构的专属工具！</td>
                </tr>
                <tr>
                    <td>EVA分析——评估经营者为企业创造价值的能力。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <div>【孙健】&nbsp;文华产品经理</div>
            <div  class="index-module_textWrap_3ygOc">
                十年来专注于套利及量化交易研究工作，每年多次在全国范围内举办和参与套利和量化方面的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
    padding: 5px 0;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
</style>